export default __webpack_public_path__ + "static/media/hango-screenshot-02.2bdfb8b9.png";